import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPackagesQueryVariables = GraphQLTypes.Exact<{
  adminIds?: GraphQLTypes.InputMaybe<Array<GraphQLTypes.Scalars['String']> | GraphQLTypes.Scalars['String']>;
  dateRangeFilterType?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']>;
  dateRange?: GraphQLTypes.InputMaybe<GraphQLTypes.DateRange>;
}>;


export type GetPackagesQueryResult = (
  { __typename?: 'Query' }
  & { getPackages: Array<(
    { __typename?: 'Package' }
    & Pick<GraphQLTypes.Package, 'id' | 'packageName' | 'netTotal' | 'createdAt' | 'startDate'>
    & { createdBy?: GraphQLTypes.Maybe<(
      { __typename?: 'Admin' }
      & Pick<GraphQLTypes.Admin, 'id' | 'firstName' | 'lastName'>
    )>, customer?: GraphQLTypes.Maybe<(
      { __typename?: 'Customer' }
      & Pick<GraphQLTypes.Customer, 'id' | 'firstName' | 'lastName'>
    )>, customerPayment?: GraphQLTypes.Maybe<(
      { __typename?: 'PackagePayment' }
      & Pick<GraphQLTypes.PackagePayment, 'id'>
      & { total?: GraphQLTypes.Maybe<(
        { __typename?: 'PaymentType' }
        & Pick<GraphQLTypes.PaymentType, 'amount'>
      )> }
    )> }
  )> }
);


export const GetPackagesDocument = /*#__PURE__*/ gql`
    query getPackages($adminIds: [String!], $dateRangeFilterType: String, $dateRange: DateRange) {
  getPackages(
    adminIds: $adminIds
    dateRangeFilterType: $dateRangeFilterType
    dateRange: $dateRange
  ) {
    id
    packageName
    netTotal
    createdAt
    startDate
    createdBy {
      id
      firstName
      lastName
    }
    customer {
      id
      firstName
      lastName
    }
    customerPayment {
      id
      total {
        amount
      }
    }
  }
}
    `;

/**
 * __useGetPackagesQuery__
 *
 * To run a query within a React component, call `useGetPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesQuery({
 *   variables: {
 *      adminIds: // value for 'adminIds'
 *      dateRangeFilterType: // value for 'dateRangeFilterType'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagesQueryResult, GetPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesQueryResult, GetPackagesQueryVariables>(GetPackagesDocument, options);
      }
export function useGetPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesQueryResult, GetPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesQueryResult, GetPackagesQueryVariables>(GetPackagesDocument, options);
        }
export type GetPackagesQueryHookResult = ReturnType<typeof useGetPackagesQuery>;
export type GetPackagesLazyQueryHookResult = ReturnType<typeof useGetPackagesLazyQuery>;